import axios from 'axios'
import Vue from 'vue'
import qs from "qs";

const state = {
    usersByDepartmentList: [],
    editUser: [],
    editGroup: [],
    dismissUsers: [],
    refuseUsers: [],
    userSectRightLoader: false,
    userRights: {
        '0': false,
        '1': 'R',
        '2': 'W', 
        '28': 'C',
    },
    form: {}
}

const getters = {

}

const mutations = {
    setUsersByDepartmentList(state, data) {
        if (typeof data === 'object' && data.items !== undefined) {
            Vue.set(state,'usersByDepartmentList', data.items);
            Vue.set(state,'dismissUsers', data.dismissUsers);
            Vue.set(state,'refuseUsers', data.refuseUsers);
        }
    },
    setEditUser(state, data) {
        state.editUser = data;
    },
    addUser(state, data){
        for (let i in state.usersByDepartmentList) {
            if(state.usersByDepartmentList[i].id == data.id){
                state.usersByDepartmentList[i].users.push(data.users[0]);    
            }    
        }
    },
    refreshUser(state, data){
        for (let i in state.usersByDepartmentList) {
            if(state.usersByDepartmentList[i].id == data.id){
                for (let k in state.usersByDepartmentList[i].users) {
                    if(state.usersByDepartmentList[i].users[k].id == data.users[0].id){
                        state.usersByDepartmentList[i].users[k] = data.users[0]; 
                    }
                }
            }    
        }
    },
    removeUser(state, data){
        for (let i in state.usersByDepartmentList) {
            for (let k in state.usersByDepartmentList[i].users) {
                if(state.usersByDepartmentList[i].users[k].id == data){
                    //state.usersByDepartmentList[i].users[k] = data.users[0]; 
                    state.usersByDepartmentList[i].users.splice(k, 1);
                }
            } 
        }
    },
    removeGroup(state, data){
        let index = state.usersByDepartmentList.findIndex(sect => sect.id === data); 
        state.usersByDepartmentList.splice(index, 1);
    },
    kickUnReadBtnType(state, data){
        for (let i in state.usersByDepartmentList) {
            for (let k in state.usersByDepartmentList[i].users) {
                if(state.usersByDepartmentList[i].users[k].id == data.id){
                    Vue.set(state.usersByDepartmentList[i].users[k],'kickUnReadBtnType',data.type);
                }
            }
        }
    },
    userBanned(state, data){
        for (let i in state.usersByDepartmentList) {
            for (let k in state.usersByDepartmentList[i].users) {
                if(state.usersByDepartmentList[i].users[k].id == data){
                    state.usersByDepartmentList[i].users[k].banned = true;
                }
            }
        }
        state.editUser.banned = true;
    },
    userUnBanned(state, data){
        for (let i in state.usersByDepartmentList) {
            for (let k in state.usersByDepartmentList[i].users) {
                if(state.usersByDepartmentList[i].users[k].id == data){
                    state.usersByDepartmentList[i].users[k].banned = false;
                }
            }
        }
        state.editUser.banned = false;
    },
    moveUpGroup(state, data){
        if (data === 0) { // if its the first in the array
            state.usersByDepartmentList.push(state.usersByDepartmentList.shift()) // same as option 1
        } else {
            let array = state.usersByDepartmentList.map((element, i) => { // iterate array and change places
                if (i === data - 1) {
                    return state.usersByDepartmentList[data];
                } else if (i === data) {
                    return state.usersByDepartmentList[data - 1];
                } else {
                    return element;
                }
            });
            state.usersByDepartmentList = array;
        }
    },
    moveDownGroup(state, data){
        if (data === state.usersByDepartmentList.length-1) { // if its the last in the array
            state.usersByDepartmentList.unshift(state.usersByDepartmentList.pop()) // same as option 1
        } else {
            let array = state.usersByDepartmentList.map((element, i) => { // iterate array and change places
                if (i === data) {
                    return state.usersByDepartmentList[data + 1];
                } else if (i === data + 1) {
                    return state.usersByDepartmentList[data];
                } else {
                    return element;
                }
            });
            state.usersByDepartmentList = array;
        }
    },
    moveGroup(state, data){
        state.usersByDepartmentList = data;
    },
    setEditGroup(state, data){
        state.editGroup = data; 
    },
    renameGroup(state, data){
        let index = state.usersByDepartmentList.findIndex(sect => sect.id === data.id); 
        state.usersByDepartmentList[index].name = data.name;
    },
    addGroup(state, data){
        state.usersByDepartmentList.push(data);    
    },
    setUsersByDepartmentListByIndex(state, data){
        state.usersByDepartmentList[data.index].users = data.items;    
    },
    setUserSectRight(state, data){
        if(state.userRights[data.val] == false){
            if(state.usersByDepartmentList[data.index].users[data.indexUser].rights[data.curSect]){
                Vue.delete(state.usersByDepartmentList[data.index].users[data.indexUser].rights, data.curSect);     
            }
        }
        else{
            Vue.set(state.usersByDepartmentList[data.index].users[data.indexUser].rights,data.curSect, state.userRights[data.val]);
        }
    },
    setUserSectRightLoader(state, data){
        state.userSectRightLoader = data;
    },
    setUserForm(state, data){
        state.form = data;
    }
}

const actions = {
    getUsersByDepartment(context, data) {
        return new Promise((resolve, reject) => {
            let params =  {
                type:'getUsersByDepartment',
                withScheme: data && data.withScheme ? 1 : 0
            };
            axios.get(process.env.VUE_APP_API_PATH + '/rules/user/', {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false
                },
                withCredentials: true,
                params: params,
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if (typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('setUsersByDepartmentList', response.data.result);
                } else {
                    if (+response.data.error === 401) {
                        if (response.data.result.user.login === null) {
                            context.dispatch('auth/logout',{},{root:true})
                        } else {
                            context.commit('auth/setIsNoSuccessSection', {}, {root: true})
                        }
                    }
                }
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    addUser(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/user/';
            if(data.id){
                url +=  data.id+'/';
            }
            let paramsData = data;

            let formData = new FormData();
            for ( let key in data.form ) {
                formData.append(key, data.form[key]);
            }

            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    if(response.data.result.status != 'error'){
                        if(paramsData.id){
                            if(context.state.editUser.department == response.data.result.items.id){
                                context.commit('refreshUser',  response.data.result.items);
                            }
                            else{
                                context.commit('removeUser',  paramsData.id);
                                context.commit('addUser',  response.data.result.items);
                            }

                        }else{
                            context.commit('addUser',  response.data.result.items);
                        }
                    }

                }
                resolve(response.data.result);
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    checkUser(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/user/';
            let formData = new FormData();
            for ( let key in data.form ) {
                formData.append(key, data.form[key]);
            }
            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                resolve(response.data.result);
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    getUsersByID(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/user/';
            if(data.id){
                url +=  data.id+'/';
            }

            axios.get(url, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                params: {

                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    if(response.data.result.status != 'error'){
                        context.commit('setEditUser',  response.data.result.item);
                    }
                }
                resolve(response.data.result);
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    userBanned(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/user/';
            if(data.id){
                url +=  data.id+'/';
            }
            let formData = new FormData();
            formData.append('type','userBanned')
            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('userBanned',  data.id);
                }
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    userRefuse(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/user/';
            if(data.id){
                url +=  data.id+'/';
            }
            let formData = new FormData();
            formData.append('type','userRefuse')
            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('userBanned',  data.id);
                }
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    userUnBanned(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/user/';
            if(data.id){
                url +=  data.id+'/';
            }
            let formData = new FormData();
            formData.append('type','userUnBanned')
            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('userUnBanned',  data.id);
                }
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
    setMoveGroup(context, data){
        return new Promise((resolve, reject) => {

            if(data.direction == 'up'){
                context.commit('moveUpGroup',data.index);
            } else{
                context.commit('moveDownGroup',data.index);    
            }
            let url = process.env.VUE_APP_API_PATH+'/rules/user/';
            let formData = new FormData();
            let ids = [];
            formData.append('type', 'setGroupSort');
            for (let i in context.state.usersByDepartmentList) {
                ids.push(context.state.usersByDepartmentList[i].id);
            }
            formData.append('ids', JSON.stringify(ids));

            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                resolve();    
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });   
    },
    setGroupSort(context, data){
        return new Promise((resolve, reject) => {

            context.commit('moveGroup', data);
            let url = process.env.VUE_APP_API_PATH+'/rules/user/';
            let formData = new FormData();
            let ids = [];
            formData.append('type', 'setGroupSort');
            for (let i in context.state.usersByDepartmentList) {
                ids.push(context.state.usersByDepartmentList[i].id);
            }
            formData.append('ids', JSON.stringify(ids));

            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                resolve();
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });
    },
    setUserSort(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/user/'; 
            let formData = new FormData();
            formData.append('type', 'setUsersSort');
            formData.append('group', context.state.usersByDepartmentList[data.index].id);
            let ids = [];
            for (let i in context.state.usersByDepartmentList[data.index].users) {
                ids.push(context.state.usersByDepartmentList[data.index].users[i].ufId);
            }
            formData.append('ids', JSON.stringify(ids));
            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                resolve();    
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });    
    },
    setGroup(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/user/';
            if(data.id){
                url +=  data.id+'/';
            }

            let formData = new FormData();
            formData.append('name', data.name);
            formData.append('type', 'saveGroup');

            axios.post(url,formData, {
                headers: {'Content-Type': 'application/json;charset=utf-8','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
            }).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    if(data.id){
                        context.commit('renameGroup',  data); 
                    } else{
                        context.commit('addGroup',  response.data.result.items);     
                    }
                    resolve();
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
            });
        });
    },
    removeGroup(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/user/'+data.id+'/';
            let formData = new FormData();
            formData.append('type', 'removeGroup'); 

            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(response.data.result){
                    context.commit('removeGroup',data.id);   
                    resolve(true);
                }else{
                    resolve(false);
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });
    },
    setUserSectRight(context, data){
        return new Promise((resolve, reject) => {
            context.commit('setUserSectRight',{val: data.val, index: data.index, indexUser: data.indexUser, curSect: data.curSect});
            context.commit('setUserSectRightLoader',true);
            let userId = context.state.usersByDepartmentList[data.index].users[data.indexUser].id
            let url = process.env.VUE_APP_API_PATH+'/rules/user/'+userId+"/";
            let formData = new FormData();
            formData.append('type', 'setUserRight');
            formData.append('curSect', data.curSect);
            formData.append('val', data.val);

            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(response.data.result){
                    resolve(true);
                }else{
                    resolve(false);
                }
                setTimeout(()=>{
                    context.commit('setUserSectRightLoader',false);
                },1500);
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });    
    },
    kickUnRead(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/user/'+data.id+"/";
            let formData = new FormData();
            formData.append('type', 'kickUnRead');

            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(response.data.result){
                    resolve(true);
                }else{
                    resolve(false);
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });
    },
    kickUnReadAll(context, data){
        return new Promise((resolve, reject) => {
            let url = process.env.VUE_APP_API_PATH+'/rules/user/';
            let formData = new FormData();
            formData.append('type', 'kickUnReadAll');

            axios.post(url, formData, {
                headers: {'Content-Type': 'multipart/form-data','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                },
            }).then(response => {
                if(response.data.result){
                    resolve(true);
                }else{
                    resolve(false);
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                resolve();
            });
        });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}